import { useTranslation } from 'react-i18next';

import { Button, Checkbox, Chip, Icon, Link, StandardCard, Typography } from '@/components';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
} from '@/components/dialog';
import { Route as RoutePath } from '@/constants';
import { ChangeEvent, useState } from 'react';
import { useUpdateUserMutation } from '@/features/users';

export type PreferencesModalProps = {
  readonly open?: boolean;
  readonly setOpen: (state: boolean) => void;
};

export function TermsAndConditionsModal({ open, setOpen }: PreferencesModalProps) {
  const { t } = useTranslation(['settings']);
  const [accepted, setAccepted] = useState(false);
  const [updateUser] = useUpdateUserMutation();

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogPortal>
        <DialogOverlay />
        <DialogContent
          onPointerDownOutside={(event) => event.preventDefault()}
          onEscapeKeyDown={(event) => event.preventDefault()}
          canClose={false}
          className="p-8"
        >
          <DialogHeader className="mb-2 flex-row items-center gap-3">
            <DialogTitle className="font-bold">
              <div className="flex">
                <Icon name="file-text" className="mr-2" /> {t('Updated Terms and Conditions')}
              </div>
              <Chip color="default" className="pt-1 capitalize">
                <div className="h-1 w-1 rounded-full bg-neutral-900" />
                {t('Effective January 1, 2026')}
              </Chip>
            </DialogTitle>
          </DialogHeader>

          <form id="terms-and-conditions-form" onSubmit={() => {}}>
            <div className="space-y-6">
              <div className="space-y-0.5">
                <Typography as="p" color="primary" size="body-2" weight="normal" className="mt-2">
                  {t('To continue using the platform, please review and accept the updated Terms and Conditions.')}
                </Typography>
              </div>
              <Checkbox
                id="terms_and_conditions_accepted"
                color="primary"
                checked={accepted}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setAccepted(e.target.checked)}
              >
                <Typography as="p" color="secondary" size="body-2" weight="normal">
                  {t('I have read and accept the updated ')}
                  <Link to={RoutePath.TermsAndConditions} target="_blank">
                    {t('Terms and Conditions')}
                  </Link>
                </Typography>
              </Checkbox>
            </div>
          </form>
          <DialogFooter className="flex items-center justify-between gap-3 pt-3">
            <Button
              onClick={() => {
                updateUser({ show_modal_ttcc: false, accepted_ttcc: true });
                setOpen(false);
              }}
              disabled={!accepted}
              color="primary"
              className="w-full px-8 py-2 text-white"
            >
              {t('Accept and continue')}
            </Button>
          </DialogFooter>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
}
